import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { CallsLive } from './-components/calls-live';
import { LineAssignments } from './-components/line-assignments';
import { LinesSection } from './-components/lines-section';
import { SettingsSection } from './-components/settings-section';
import { Skeleton } from '~/components/ui/skeleton';

export const Route = createFileRoute('/_dashboard/settings/calls')({
  component: SettingsCallsRoute,
});

// Each section waits for its own data, so live calls arrive without the
// configuration behind them.
function SettingsCallsRoute() {
  return (
    <>
      <Suspense fallback={<CallsLivePending />}>
        <CallsLive />
      </Suspense>
      <Suspense fallback={<LineAssignmentsPending />}>
        <LineAssignments />
      </Suspense>
      <Suspense fallback={null}>
        <LinesSection />
      </Suspense>
    </>
  );
}

function CallsLivePending() {
  const { t } = useTranslation('settings');

  return (
    <SettingsSection.Wrapper aria-busy="true">
      <SettingsSection.Header>
        <SettingsSection.Title>{t('Active calls')}</SettingsSection.Title>
        <SettingsSection.Description>
          {t('Calls happening right now, and where each one has got to')}
        </SettingsSection.Description>
      </SettingsSection.Header>
      <SettingsSection.ContentWrapper className="border-b-0">
        <div className="space-y-3">
          {Array.from({ length: 2 }, (_, index) => (
            <Skeleton key={index} className="h-20 w-full rounded-lg" />
          ))}
        </div>
      </SettingsSection.ContentWrapper>
    </SettingsSection.Wrapper>
  );
}

function LineAssignmentsPending() {
  const { t } = useTranslation('settings');

  return (
    <SettingsSection.Wrapper aria-busy="true">
      <SettingsSection.Header>
        <SettingsSection.Title>{t('Calls')}</SettingsSection.Title>
        <SettingsSection.Description>
          {t('Choose which SIP line each receptionist uses')}
        </SettingsSection.Description>
      </SettingsSection.Header>
      <SettingsSection.ContentWrapper className="border-b-0">
        <div className="space-y-3">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-14 w-full" />
        </div>
      </SettingsSection.ContentWrapper>
    </SettingsSection.Wrapper>
  );
}
